import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import v4 from 'uuid';
import { propBool, propFunc, propShape, propStr, } from '../../../../../helpers/custom-prop-types';
import PlainInput from '../../../../Ui/Common/PlainInput';
const ColumnCheckBox = (props) => {
    const { input, isDisabled, label, meta, wrapOnChange } = props;
    const id = useMemo(() => v4(), []);
    return (_jsxs("li", Object.assign({ className: `mr05 mb1 ${isDisabled ? 'is-disabled' : ''}` }, { children: [_jsx(PlainInput, { checked: input.value, className: 'mdc-checkbox__native-control', disabled: isDisabled, id: id, input: input, meta: meta, type: 'checkbox', wrapOnChange: wrapOnChange }), _jsx("label", Object.assign({ htmlFor: id }, { children: _jsx("span", { children: label }) }))] })));
};
ColumnCheckBox.propTypes = {
    input: propShape().isRequired,
    isDisabled: propBool().isRequired,
    label: propStr().isRequired,
    meta: propShape().isRequired,
    wrapOnChange: propFunc(),
};
ColumnCheckBox.defaultProps = {
    wrapOnChange: undefined,
};
export default ColumnCheckBox;
